module.exports = "/images/coin.svg?d2297a4a67a9f89f30030e923dd4612c";